import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AreaSelectDialog from './area-select-dialog';
export default {
  name: 'AreaSelect',
  props: {
    multiple: {
      // 是否支持多选
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    value: {
      // 选中的值
      // eslint-disable-next-line vue/require-prop-type-constructor,no-bitwise
      type: Array | String,
      default: function _default() {
        return [];
      }
    },
    rootOrgId: {
      // 根机构限定
      type: String,
      default: '100000'
    },
    placeholder: {
      // 提示文字
      type: String,
      default: '请选择部门'
    },
    closePopoverFlag: {
      // 是否可以编辑
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    needPathId: {
      // 是否需要Pathid
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    modal: {
      // 是否需要遮罩
      type: Boolean,
      default: true
    },
    isShowAllPath: {
      // 是否展示全路徑
      type: Boolean,
      default: false
    },
    disabled: {
      // 是否需要遮罩
      type: Boolean,
      default: false
    },
    collapse: {
      // 是否需要折叠选中项
      type: Boolean,
      default: true
    },
    returnType: {
      type: String,
      default: 'String'
    },
    modalAppendToBody: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    appendToBody: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  components: {
    AreaSelectDialog: AreaSelectDialog
  },
  computed: {
    defaultCitys: {
      set: function set() {},
      get: function get() {
        if (this.multiple) {
          return this.value;
        } else {
          if (this.value && !Array.isArray(this.value)) {
            return [this.value];
          } else {
            return [];
          }
        }
      }
    },
    selectedTitle: {
      set: function set() {},
      get: function get() {
        if (this.options.length > 0) {
          return this.options[0].label;
        } else {
          return '';
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.defaultCitys instanceof Array && this.defaultCitys.length > 0) {
      this.$API.getRequest({
        url: '/punish/administrativePunish/lawEnforcementRegion'
      }).then(function (res) {
        var selsecArr = [];
        // eslint-disable-next-line array-callback-return
        res.result.filter(function (item) {
          if (_this.defaultCitys.indexOf(item.id) > -1) {
            selsecArr.push(item);
          }
          if (item.city) {
            // eslint-disable-next-line array-callback-return
            item.city.filter(function (val) {
              if (_this.defaultCitys.indexOf(val.id) > -1) {
                selsecArr.push(val);
              }
            });
          }
        });
        _this.options = selsecArr.map(function (city) {
          return {
            value: city.id,
            label: city.cityName
          };
        });
        if (_this.multiple) {
          _this.selectedArray = selsecArr.map(function (city) {
            return city.id;
          });
        } else {
          _this.selectedArray = selsecArr.map(function (city) {
            return city.id;
          })[0];
        }
      });
    }
  },
  data: function data() {
    return {
      selectedArray: [],
      // 选中的部门
      options: [],
      // 待选列表
      orgVisible: false // 显示部门列表的弹窗开关
    };
  },

  watch: {
    // value(orgs) {
    //   if (this.defaultCitys instanceof Array && this.defaultCitys.length > 0) {
    //    this.$API.getRequest({url: `/punish/administrativePunish/lawEnforcementRegion`}).then((res) => {
    //       const cityArr = res.result;
    //       this.options = cityArr.map((city) => {
    //         return {
    //           value: city.id,
    //           label: city.cityName,
    //         };
    //       });
    //       if (this.multiple) {
    //         this.selectedArray = cityArr.map((city) => city.id);
    //       } else {
    //         this.selectedArray = cityArr.map((city) => city.id)[0];
    //       }
    //     });
    //   } else {
    //     this.options = [];
    //     this.selectedArray = null;
    //   }
    // },
  },
  methods: {
    closeIt: function closeIt() {
      this.$refs.selectIt.blur();
    },
    // 监听选择
    changeSelect: function changeSelect(orgs) {
      this.selectedArray = orgs;
      this.$emit('input', this.selectedArray);
    },
    // 点击确定按钮
    handleConfirm: function handleConfirm(data) {
      if (this.multiple) {
        this.selectedArray = data.map(function (city) {
          return city.id;
        });
        this.$emit('input', this.returnType === 'String' ? this.selectedArray : data);
      } else {
        this.selectedArray = data.map(function (city) {
          return city.id;
        })[0];
        this.$emit('input', this.returnType === 'String' ? this.selectedArray : data[0]);
      }
      this.options = data.map(function (data) {
        return {
          value: data.id,
          label: data.cityName
        };
      });

      // if (this.needPathId) {
      //   this.$emit("userSelectChange", data[0].pathId);
      // }
      this.$emit('onChange', this.options);
      this.orgVisible = false;
    },
    // 取消
    clickHandler: function clickHandler() {
      if (this.disabled) return false;
      this.orgVisible = true;
      if (this.closePopoverFlag) {
        this.$emit('orgClick');
      }
    }
  }
};